export const images = {
    powerplaylogo: require('./../assets/images/powerplay-logo.svg'),
    imgupload:require('./../assets/images/img-upload.svg'),
    deletesport:require('./../assets/images/delete.svg'),
    deletetable:require('./../assets/images/delete-icon-table.svg'),
    viewtable:require('./../assets/images/view-icon-table.svg'),
    edittable:require('./../assets/images/edit-icon-table.svg'),
    qrcode:require('./../assets/images/qr-code.svg'),
    powerplayicon:require('./../assets/images/powerplay-logo-icon.svg'),
    rightarrow:require('./../assets/images/arrow-right.svg'),
    leftarrow:require('./../assets/images/arrow-left.svg'),
    uploadicon:require('./../assets/images/upload-icon.svg'),
    backbtn:require('./../assets/images/back-btn.svg'),
    refereshchart:require('./../assets/images/refresh-chart.svg'),
    powerplaylogowhite:require('./../assets/images/powerplay-logo-white.svg'),
    courticon:require('./../assets/images/court.svg'),
    customercourticon:require('./../assets/images/customer-court-icon.svg'),
    customercoachingicon:require('./../assets/images/customer-coaching-icon.svg'),
    customerbookingicon:require('./../assets/images/customer-booking-icon.svg'),
    customerhistoryicon:require('./../assets/images/customer-history-icon.svg'),
    ballicon:require('./../assets/images/cricket.svg'),
    cricketnetsicon:require('./../assets/images/net-cricket.svg'),
    footballicon:require('./../assets/images/football.svg'),
    badmintonicon:require('./../assets/images/badminton.svg'),
    vollyballicon:require('./../assets/images/vollyball.svg'),
    tabletennisicon:require('./../assets/images/table-tennis.svg'),
    throwballicon:require('./../assets/images/throw-ball.svg'),
    mapicon:require('./../assets/images/map-pin-icon.svg'),
    updateicon:require('./../assets/images/edit-icon.svg'),
    paymentsuccess:require('./../assets/images/payment-success.svg'),
    paymentcancelled:require('./../assets/images/payment-failed.svg')
}
  